import React, {useState, useEffect, useReducer} from "react";

// ------------ Lib ------------------
import {FormattedNumber} from 'react-intl';

// ------------ Components ------------
import {Modal as CustomModal} from "@redq/reuse-modal";
import {
  Row,
  Col,
  Button,
  Form,
  ListGroup,
  Toast,
  Spinner,
  Tab, Tabs, Table, Modal
} from "react-bootstrap";
import {Switch, Checkbox, FormControlLabel, Chip, Dialog, DialogTitle, DialogContent, DialogActions, LinearProgress, Tooltip, Button as MButton, TableContainer, Table as MTable, TableHead, TableCell, TableBody, TableRow, Paper, TablePagination, makeStyles } from "@material-ui/core";
import EditIcon from '@material-ui/icons/Edit';
import History from "@material-ui/icons/History";
import moment from "moment";
import Loader from "../../../components/Loader/Loader";
import _ from 'lodash';

// -------------- APIs ---------------
import API from "../../../network/dashboardAPI";

// -------------- Style --------------
import styled from "styled-components";
import "react-datetime/css/react-datetime.css";
import {ACTIONS, settingListReducer} from "./reducer/settingList";
import {ACTIONS_UPDATE_REDUCER, formSettingReducer} from "./reducer/formSetting";
import {ACTIONS_EXPRESS_SETTING_REDUCER, formExpressSettingReducer} from "./reducer/formExpressSetting";


const HelpPageWrapper = styled.div`
  background-color: #f7f7f7;
  position: relative;
  padding: 50px 0 50px 0;
  
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  
  .tabProfile {
    border-bottom: 1px solid #ddd !important;
    justify-content: center;
    margin-bottom: 20px;
  }

  @media (max-width: 989px) {
    padding-top: 70px;
  }
`;

const TableContent = styled.div`
	table {
		thead tr th {
			width: initial;
			vertical-align: middle;
      font-weight: 700;
      font-size: 0.95rem;
      background: #efefef;
		}

		tbody tr td {
      vertical-align: middle;
      white-space: nowrap;
      font-size: 0.95rem;
      
      &.modified {
        color: #ff963e; 

        &.allowedPaymentMethod {
          & > * {
            color: #ff963e;
            border-color: #ff963e;
          }
        }
      }
		}
	}

  .MuiDialogContent-dividers {
    padding: 16px;
  }

  .MuiTableContainer-root {
    ::-webkit-scrollbar {
      width: 9px;
      height: 9px;
      border-radius: 3px;
    }
  
    ::-webkit-scrollbar-thumb {
      background: #dee2e6;
      border-radius: 3px;

      &:hover {
        background: #9c9a9a;
      }
    }
  }

`;

const labelStyle = {
  lineHeight: "2rem"
}

const validate = (values) => {
  const errors = {};
  if (!values.label) {
    errors.label = 'Required';
  }

  if (!(values.deliveryMaxRange || values.deliveryMaxRange === 0)) {
    errors.deliveryMaxRange = 'Required';
  } else if (values.deliveryMaxRange < 0) {
    errors.deliveryMaxRange = 'Must be greater than 0';
  }

  if (!(values.deliveryFeePerKm || values.deliveryFeePerKm === 0)) {
    errors.deliveryFeePerKm = 'Required';
  } else if (values.deliveryFeePerKm < 0) {
    errors.deliveryFeePerKm = 'Must be greater than 0';
  }

  if (!(values.itemTotalToMakeDeliveryCostFree || values.itemTotalToMakeDeliveryCostFree === 0)) {
    errors.itemTotalToMakeDeliveryCostFree = 'Required';
  } else if (values.itemTotalToMakeDeliveryCostFree < 0) {
    errors.itemTotalToMakeDeliveryCostFree = 'Must be greater than 0';
  }

  if (!(values.deliveryFeeFixed || values.deliveryFeeFixed === 0)) {
    errors.deliveryFeeFixed = 'Required';
  } else if (values.deliveryFeeFixed < 0) {
    errors.deliveryFeeFixed = 'Must be greater than 0';
  }

  if (!values.allowedPaymentMethod.length) {
    errors.allowedPaymentMethod = 'Required';
  }

  return errors;
};

const expressValidate = (values) => {
  const errors = {};
  if (values.isEnable === null) {
    errors.isEnable = 'Required';
  }

  if (values.slotCount === null) {
    errors.slotCount = 'Required';
  } else if (values.slotCount < 0) {
    errors.slotCount = 'Must be greater than 0';
  }

  if (values.deliveryMaxRange === null) {
    errors.deliveryMaxRange = 'Required';
  } else if (values.deliveryMaxRange < 0) {
    errors.deliveryMaxRange = 'Must be greater than 0';
  }

  if (values.expressDeliveryFeePerKm === null) {
    errors.expressDeliveryFeePerKm = 'Required';
  } else if (values.expressDeliveryFeePerKm < 0) {
    errors.expressDeliveryFeePerKm = 'Must be greater than 0';
  }

  if (values.itemTotalToMakeDeliveryCostFree === null) {
    errors.itemTotalToMakeDeliveryCostFree = 'Required';
  } else if (values.itemTotalToMakeDeliveryCostFree < 0) {
    errors.itemTotalToMakeDeliveryCostFree = 'Must be greater than 0';
  }

  if (values.expressDeliveryFeeFixed === null) {
    errors.expressDeliveryFeeFixed = 'Required';
  } else if (values.expressDeliveryFeeFixed < 0) {
    errors.expressDeliveryFeeFixed = 'Must be greater than 0';
  }

  if (values.defaultEstimateDeliveryMinute === null) {
    errors.defaultEstimateDeliveryMinute = 'Required';
  } else if (values.defaultEstimateDeliveryMinute < 0) {
    errors.defaultEstimateDeliveryMinute = 'Must be greater than 0';
  }

  return errors;
};

const useStyles = makeStyles({
  topScrollPaper: {
    alignItems: 'flex-start',
  },
  topPaperScrollBody: {
    verticalAlign: 'top',
  },
});

const DeliExpressSettings = (props) => {
  /*
  *   =============== States =================
  * */
  const initialSettingState = {
    settings: [],
    loading: false,
    error: null
  }
  const [settingState, dispatch] = useReducer(settingListReducer, initialSettingState);
  const {settings, loading, error} = settingState;

  /*
  *  ================ Form State =======================
  * */
  const initialFormValues = {
    id: null,
    deliveryMaxRange: 0,
    deliveryFeePerKm: 0,
    itemTotalToMakeDeliveryCostFree: 0,
    label: "",
    type: null,
    deliveryFeeFixed: 0,
    allowedPaymentMethod: []
  };

  const initialFormState = {
    formValues: initialFormValues,
    isSubmitting: false,
    submitError: null
  }
  const [formState, dispatchFormState] = useReducer(formSettingReducer, initialFormState);
  const {formValues, isSubmitting, submitError} = formState;
  const [formErrors, setFormErrors] = useState({
    label: null,
    deliveryMaxRange: null,
    deliveryFeePerKm: null,
    itemTotalToMakeDeliveryCostFree: null,
    deliveryFeeFixed: null,
    allowedPaymentMethod: null
  });

  const initialFormExpressState = {
    formExpressSettingState: {
      id: null,
      isEnable: false,
      slotCount: 0,
      deliveryMaxRange: 0,
      expressDeliveryFeePerKm: 0,
      itemTotalToMakeDeliveryCostFree: 0,
      expressDeliveryFeeFixed: 0,
      defaultEstimateDeliveryMinute: 0,
      provinceDeliveryPrice: 0,
      latitude: 0,
      longitude: 0
    },
    isSubmittingExpressSetting: false,
    submitExpressSettingError: null
  }

  const [expressSettingState, dispatchFormExpressSetting] = useReducer(formExpressSettingReducer, initialFormExpressState);
  const {formExpressSettingState, isSubmittingExpressSetting, submitExpressSettingError} = expressSettingState;
  const [formExpressSettingErrors, setFormExpressSettingErrors] = useState({
    isEnable: null,
    slotCount: null,
    deliveryMaxRange: null,
    expressDeliveryFeePerKm: null,
    itemTotalToMakeDeliveryCostFree: null,
    expressDeliveryFeeFixed: null,
    defaultEstimateDeliveryMinute: null,
  })


  // Taps states
  const [type, setType] = useState(0);

  // Modals
  const [isShowUpdateModal, setIsShowUpdateModal] = useState(false);

  // toast states
  const [toastBgColor, setToastBgColor] = useState('bg-success');
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("Delete successful");

  const [previousNormalSettings, setPreviousNormalSettings] = useState({});
  const [previousExpressSettings, setPreviousExpressSettings] = useState({});
  const [settingId, setSettingId] = useState({ express: null, normal: null });
  const [page, setPage] = useState({ express: 0, normal: 0 });
  const [limit, setLimit] = useState({ express: 5, normal: 5 });
  const [openDialog, setOpenDialog] = useState({ express: false, normal: false });
  const [dialogLoading, setDialogLoading] = useState({ express: false, normal: false });
  const classes = useStyles();

  // fetch [normal] previous delivery settings
  function getNormalDeliverySettingHistory(id, page, limit) {
    setDialogLoading({ ...dialogLoading, normal: true });
    const params = { id, page: page + 1, limit };
    API.getNormalDeliverySettingHistory(params)
      .then((res) => res.json())
      .then(((res) => {
        if(res.success) {
          setDialogLoading({ ...dialogLoading, normal: false });
          setPreviousNormalSettings(res.data);
        }
      }))
      .catch((err) => {
        setDialogLoading({ ...dialogLoading, normal: false });
        alert(err?.message);
      });
  }

  // fetch [express] previous delivery settings
  function getExpressDeliverySettingHistory(id, page, limit) {
    setDialogLoading({ ...dialogLoading, express: true });
    const params = { id, page: page + 1, limit };
    API.getExpressDeliverySettingHistory(params)
      .then((res) => res.json())
      .then(((res) => {
        if(res.success) {
          setDialogLoading({ ...dialogLoading, express: false });
          setPreviousExpressSettings(res.data);
        }
      }))
      .catch((err) => {
        setDialogLoading({ ...dialogLoading, express: true });
        alert(err?.message);
      });
  }

  // toggle [normal] dialog
  function handleToggleNormalDialog(type, id = null){
    return () => {
      if(type === "open") {
        setOpenDialog({ ...openDialog, normal: true });
        setSettingId({ ...settingId, normal: id });
        getNormalDeliverySettingHistory(id, page.normal, limit.normal);
      } else {
        setOpenDialog({ ...openDialog, normal: false });
        setPage({ ...page, normal: 0 });
        setLimit({...limit, normal: 5 });
      }
    }
  }

  // toggle [express] dialog
  function handleToggleExpressDialog(type, id = null){
    return () => {
      if(type === "open") {
        setOpenDialog({ ...openDialog, express: true });
        setSettingId({ ...settingId, express: id });
        getExpressDeliverySettingHistory(id, page.express, limit.express)
      } else {
        setOpenDialog({ ...openDialog, express: false });
        setPage({ ...page, express: 0 });
        setLimit({ ...limit, express: 5 });
      }
    }
  }

  // change [normal] table page && limit
  const handleChangeNormalPage = (event, newPage) => {
    setPage({...page, normal: newPage});
    getNormalDeliverySettingHistory(settingId.normal, newPage, limit.normal);
  };

  const handleChangeNormalRowsPerPage = (event) => {
    setPage({ ...page, normal: 0 });
    setLimit({ ...limit, normal: event.target.value });
    getNormalDeliverySettingHistory(settingId.normal, 0, event.target.value);
  };

  // change [express] table page && limit
  const handleChangeExpressPage = (event, newPage) => {
    setPage({ ...page, express: newPage });
    getExpressDeliverySettingHistory(settingId.express, newPage, limit.express);
  };

  const handleChangeExpressRowsPerPage = (event) => {
    setPage({ ...page, express: 0 });
    setLimit({...limit, express: event.target.value });
    getExpressDeliverySettingHistory(settingId.express, 0, event.target.value);
  };

  // get modified class for modified column
	function getModifiedColClass(obj, key) {
		if (typeof obj !== "object") return;
		return Object.keys(obj).find((objKey) => objKey === key) && "modified";
	}

  /*
  *   ============================ API Methods =====================
  * */
  const getAllDeliveryRule = async () => {
    dispatch({type: ACTIONS.CALL_GET_API});

    await API.getAllDeliveryRule()
        .then(res => res.json())
        .then(res => {
          if (res.success) {
            dispatch({type: ACTIONS.SUCCESS, data: res.data});
            return;
          } else if (res.data.length > 0) {
            dispatch({type: ACTIONS.ERROR, error: true});
            return;
          }
        })
  }

  const getExpressSetting = async () => {
    dispatchFormExpressSetting({type: ACTIONS_EXPRESS_SETTING_REDUCER.CALLING_API});

    await API.getExpressSetting()
        .then(res => res.json())
        .then(res => {
          if (res.success === true) {
            const data = setExpressFormData(res)
            dispatchFormExpressSetting({type: ACTIONS_EXPRESS_SETTING_REDUCER.CALL_API_SUCCESS, data});
            return;
          } else {
            dispatchFormExpressSetting({type: ACTIONS_EXPRESS_SETTING_REDUCER.CALL_API_ERROR, error: true});
            handleShowToast("ERROR");
            return;
          }
        });
  }

  // ---------------------------- Compute --------------------------
  useEffect(() => {
    getAllDeliveryRule();
  }, []);

  const handleUpdate = (row) => {
    dispatchFormState({type: ACTIONS_UPDATE_REDUCER.INITIAL_DATA, data: _.clone(row)});
    setIsShowUpdateModal(true)
  }

  const handleTypeChange = (key) => {
    if (Number(key) === 1) {
      if (!formExpressSettingState.id) {
        getExpressSetting();
      }
    } else if (Number(key) === 0) {
      if (!settings.length) {
        getAllDeliveryRule();
      }
    }

    setType(Number(key));
  }

  const handleCloseModal = () => {
    setIsShowUpdateModal(false)
    setFormErrors({
      label: null,
      deliveryMaxRange: null,
      deliveryFeePerKm: null,
      itemTotalToMakeDeliveryCostFree: null,
      deliveryFeeFixed: null,
      allowedPaymentMethod: null
    })
  }

  // Form
  const handleChange = (e) => {
    const {name, value} = e.target;
    switch (name) {
      case "allowedPaymentMethodCash":
        if(!formValues["allowedPaymentMethod"].includes("cash")){
          formValues["allowedPaymentMethod"] = formValues["allowedPaymentMethod"].concat("cash");
        }else if(formValues["allowedPaymentMethod"].includes("cash") && formValues["allowedPaymentMethod"].length > 1){
          formValues["allowedPaymentMethod"] = formValues["allowedPaymentMethod"].filter(x => x !== "cash")
        }
        break;
      case "allowedPaymentMethodOnline":
        if(!formValues["allowedPaymentMethod"].includes("online")){
          formValues["allowedPaymentMethod"] = formValues["allowedPaymentMethod"].concat("online");
        }else if(formValues["allowedPaymentMethod"].includes("online") && formValues["allowedPaymentMethod"].length > 1){
          formValues["allowedPaymentMethod"] = formValues["allowedPaymentMethod"].filter(x => x !== "online")
        }

        break;
      default:
        formValues[name] = value;
        break;
    }

    dispatchFormState({type: ACTIONS_UPDATE_REDUCER.UPDATE_DATA, data: formValues});
    setFormErrors(validate(formValues));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = validate(formValues);

    if (!getFormErrors(errors)) {
      dispatchFormState({type: ACTIONS_UPDATE_REDUCER.CALL_UPDATE_API});
      await API.updateDeliveryRuleById({param: formValues.id, body: formValues})
          .then(res => res.json())
          .then(res => {
            if (res.success) {
              dispatchFormState({type: ACTIONS_UPDATE_REDUCER.CALL_UPDATE_API_SUCCESS, data: res.data});
              dispatch({type: ACTIONS.UPDATE_SETTING_ROW, data: res.data});
              handleShowToast("SUCCESS");
              setIsShowUpdateModal(false);
              return;
            } else {
              dispatchFormState({type: ACTIONS_UPDATE_REDUCER.CALL_UPDATE_API_ERROR, error: true});
              handleShowToast("ERROR");
            }
          })
    } else {
      setFormErrors(errors);
    }
  };

  const getFormErrors = (errors) => {
    return errors.label || errors.deliveryMaxRange || errors.deliveryFeePerKm || errors.itemTotalToMakeDeliveryCostFree || errors.deliveryFeeFixed || errors.allowedPaymentMethod;
  }

  const handleExpressFormChange = (e) => {
    const {name, value} = e.target;
    if (name !== "isEnable") {
      formExpressSettingState[name] = value;

    } else {
      formExpressSettingState[name] = e.target.checked;
    }

    // formExpressSettingState[name] = value;
    dispatchFormExpressSetting({type: ACTIONS_EXPRESS_SETTING_REDUCER.UPDATE_DATA, data: formExpressSettingState});

    setFormExpressSettingErrors(expressValidate(formExpressSettingState));
  }

  const handleSubmitExpressSetting = async (e) => {
    e.preventDefault();
    const errors = expressValidate(formExpressSettingState);

    if (!getExpressFormError(errors)) {
      dispatchFormExpressSetting({type: ACTIONS_EXPRESS_SETTING_REDUCER.CALLING_API});
      const body = getExpressFormData();
      await API.updateExpressSetting(body)
          .then(res => res.json())
          .then(res => {
            if (res.success === true) {
              const data = setExpressFormData(res);
              dispatchFormExpressSetting({type: ACTIONS_EXPRESS_SETTING_REDUCER.CALL_API_SUCCESS, data});
              handleShowToast("SUCCESS");
              return;
            } else {
              if (res.error === true) {
                dispatchFormExpressSetting({type: ACTIONS_EXPRESS_SETTING_REDUCER.CALL_API_ERROR, error: true})
                handleShowToast("ERROR");
                return;
              }
            }
          });
    }
  }

  const getExpressFormError = (errors) => {
    return errors && (errors.isEnable || errors.slotCount || errors.deliveryMaxRange || errors.expressDeliveryFeePerKm || errors.itemTotalToMakeDeliveryCostFree || errors.expressDeliveryFeeFixed || errors.defaultEstimateDeliveryMinute);
  }

  const setExpressFormData = (response) => {
    const {
      default_estimate_delivery_minute,
      delivery_fee_fixed,
      delivery_fee_per_km,
      delivery_max_range,
      id,
      is_enable,
      item_total_to_make_delivery_cost_free,
      latitude,
      longitude,
      province_delivery_fee,
      slot_count,
    } = response.data;
    return {
      id,
      isEnable: is_enable,
      slotCount: slot_count,
      deliveryMaxRange: delivery_max_range,
      expressDeliveryFeePerKm: delivery_fee_per_km,
      itemTotalToMakeDeliveryCostFree: item_total_to_make_delivery_cost_free,
      expressDeliveryFeeFixed: delivery_fee_fixed,
      defaultEstimateDeliveryMinute: default_estimate_delivery_minute,
      provinceDeliveryPrice: province_delivery_fee,
      latitude,
      longitude
    };
  }

  const getExpressFormData = () => {
    return {
      id: formExpressSettingState.id,
      delivery_max_range: Number(formExpressSettingState.deliveryMaxRange),
      delivery_fee_per_km: Number(formExpressSettingState.expressDeliveryFeePerKm),
      item_total_to_make_delivery_cost_free: Number(formExpressSettingState.itemTotalToMakeDeliveryCostFree),
      delivery_fee_fixed: Number(formExpressSettingState.expressDeliveryFeeFixed),
      is_enable: formExpressSettingState.isEnable,
      slot_count: Number(formExpressSettingState.slotCount),
      default_estimate_delivery_minute: Number(formExpressSettingState.defaultEstimateDeliveryMinute),
      province_delivery_fee: Number(formExpressSettingState.provinceDeliveryPrice)
    };
  }

  // toast event
  const handleShowToast = (type) => {
    setShowToast(true);
    if (type === "SUCCESS") {
      setToastBgColor("bg-success");
      setToastMessage("Operation successful.");
    } else if (type === "ERROR") {
      setToastBgColor("bg-danger");
      setToastMessage("Operation error.");
    }
  }

  return (
      <CustomModal>
        <HelpPageWrapper>
          <Tabs
              activeKey={type}
              transition={false}
              id="noanim-tab-example"
              className="tabProfile"
              onSelect={handleTypeChange}
          >
            <Tab eventKey={0} title="Normal Settings">
              <Row className="mb-2">
                <Col sm={9}>
                  <h5>Normal Settings</h5>
                </Col>
              </Row>

              <Row className="mb-2">
                <Col sm={12}>
                  {
                    loading ?
                        <div style={{position: "fixed", left: "55%", top: "35%"}}><Loader color="#9cc54b" h="100"/>
                        </div> :
                        <Table striped bordered hover key={1}>
                          <thead>
                          <tr>
                            <th>Name</th>
                            <th>Delivery max range(km)</th>
                            <th>Delivery fee per km($)</th>
                            <th>Total amount to make free deli($)</th>
                            <th>Fixed delivery fee($)</th>
                            <th>Payment methods</th>
                            <th className="text-center">Actions</th>
                          </tr>
                          </thead>
                          <tbody>
                          {
                            settings.length > 0 ? settings.map((row, index) => (
                                <tr key={index}>
                                  <td>{row.label}</td>
                                  <td>
                                    {row.deliveryMaxRange}
                                  </td>
                                  <td>
                                    <FormattedNumber value={row.deliveryFeePerKm} style="currency" currency="USD"/>
                                  </td>
                                  <td>
                                    <FormattedNumber value={row.itemTotalToMakeDeliveryCostFree} style="currency"
                                                     currency="USD"/>
                                  </td>
                                  <td>
                                    <FormattedNumber value={row.deliveryFeeFixed} style="currency" currency="USD"/>
                                  </td>
                                  <td className="text-center">
                                    {
                                      row.allowedPaymentMethod.includes("cash") && <Chip variant="outlined" color="secondary" size="small" label="Cash" className="ml-1 mr-1"/>
                                    }
                                    {
                                      row.allowedPaymentMethod.includes("online") && <Chip variant="outlined" color="primary" size="small" label="Online" className="ml-1 mr-1"/>
                                    }
                                  </td>
                                  <td className="d-flex justify-content-center" style={{ gap: 10 }}>
                                    <Button variant="success" onClick={() => handleUpdate(row)}>
                                      <EditIcon></EditIcon>
                                    </Button>
                                    <Tooltip title="View history">
                                      <Button variant="secondary" onClick={handleToggleNormalDialog("open", row?.id)}>
                                        <History />
                                      </Button>
                                    </Tooltip>
                                  </td>
                                </tr>
                            )) : null
                          }
                          </tbody>
                        </Table>
                  }

                </Col>
              </Row>
            </Tab>
            <Tab eventKey={1} title="Express Settings">
              <Row className="mb-2">
                <Col sm={6}>
                  <h5>Express Settings</h5>
                </Col>
                <Col sm={6}>
                  <Tooltip title="View history">
                    <Button
                      variant="secondary"
                      className="float-right" 
                      onClick={handleToggleExpressDialog("open", 1)}
                    >
                      <History />
                    </Button>
                  </Tooltip>
                </Col>
              </Row>

              <Row className="mb-2">
                <Col sm={12}>
                  <Form autoComplete="false">
                    <ListGroup>
                      <ListGroup.Item>
                        <Row className="mt-2">
                          <Col sm={6}>
                            <Form.Label style={labelStyle}>Enable Express</Form.Label>
                          </Col>

                          <Col sm={6}>
                            <Switch
                                checked={formExpressSettingState.isEnable}
                                onChange={handleExpressFormChange}
                                name="isEnable"
                                color="primary"
                                disabled={isSubmittingExpressSetting}
                                inputProps={{'aria-label': 'primary checkbox'}}
                            />
                          </Col>
                        </Row>

                        <Row className="mt-2">
                          <Col sm={6}>
                            <Form.Label style={labelStyle}>
                              <div style={{lineHeight: "1"}}>Maximum orders accepted</div>
                              <div style={{fontSize: "11px", lineHeight: "2"}}>Maximum orders accepted at the same
                                time.
                              </div>
                            </Form.Label>
                          </Col>

                          <Col sm={6}>
                            <Form.Control name="slotCount" isInvalid={formExpressSettingErrors.slotCount} type="number"
                                          disabled={isSubmittingExpressSetting} min={0} placeholder="0"
                                          value={formExpressSettingState.slotCount} onChange={handleExpressFormChange}/>
                            <Form.Control.Feedback
                                type="invalid">{formExpressSettingErrors.slotCount}</Form.Control.Feedback>
                          </Col>
                        </Row>

                        <Row className="mt-2">
                          <Col sm={6}>
                            <Form.Label style={labelStyle}>Maximum delivery range(km)</Form.Label>
                          </Col>

                          <Col sm={6}>
                            <Form.Control name="deliveryMaxRange" isInvalid={formExpressSettingErrors.deliveryMaxRange}
                                          type="number" disabled={isSubmittingExpressSetting} min={0} placeholder="0"
                                          value={formExpressSettingState.deliveryMaxRange}
                                          onChange={handleExpressFormChange}/>
                            <Form.Control.Feedback
                                type="invalid">{formExpressSettingErrors.deliveryMaxRange}</Form.Control.Feedback>
                          </Col>
                        </Row>

                        <Row className="mt-2">
                          <Col sm={6}>
                            <Form.Label style={labelStyle}>Delivery fee per km($)</Form.Label>
                          </Col>

                          <Col sm={6}>
                            <Form.Control name="expressDeliveryFeePerKm"
                                          isInvalid={formExpressSettingErrors.expressDeliveryFeePerKm} type="number"
                                          disabled={isSubmittingExpressSetting} min={0} placeholder="0"
                                          value={formExpressSettingState.expressDeliveryFeePerKm}
                                          onChange={handleExpressFormChange}/>
                            <Form.Control.Feedback
                                type="invalid">{formExpressSettingErrors.expressDeliveryFeePerKm}</Form.Control.Feedback>
                          </Col>
                        </Row>

                        <Row className="mt-2">
                          <Col sm={6}>
                            <Form.Label style={labelStyle}>Total amount to make free delivery($)</Form.Label>
                          </Col>

                          <Col sm={6}>
                            <Form.Control name="itemTotalToMakeDeliveryCostFree"
                                          isInvalid={formExpressSettingErrors.itemTotalToMakeDeliveryCostFree}
                                          type="number" disabled={isSubmittingExpressSetting} min={0} placeholder="0"
                                          value={formExpressSettingState.itemTotalToMakeDeliveryCostFree}
                                          onChange={handleExpressFormChange}/>
                            <Form.Control.Feedback
                                type="invalid">{formExpressSettingErrors.itemTotalToMakeDeliveryCostFree}</Form.Control.Feedback>
                          </Col>
                        </Row>

                        <Row className="mt-2">
                          <Col sm={6}>
                            <Form.Label style={labelStyle}>Fixed delivery fee($)</Form.Label>
                          </Col>

                          <Col sm={6}>
                            <Form.Control name="expressDeliveryFeeFixed"
                                          isInvalid={formExpressSettingErrors.expressDeliveryFeeFixed} type="number"
                                          disabled={isSubmittingExpressSetting} min={0} placeholder="0"
                                          value={formExpressSettingState.expressDeliveryFeeFixed}
                                          onChange={handleExpressFormChange}/>
                            <Form.Control.Feedback
                                type="invalid">{formExpressSettingErrors.expressDeliveryFeeFixed}</Form.Control.Feedback>
                          </Col>
                        </Row>

                        <Row className="mt-2">
                          <Col sm={6}>
                            <Form.Label style={labelStyle}>Estimate delivery time(minute):</Form.Label>
                          </Col>

                          <Col sm={6}>
                            <Form.Control name="defaultEstimateDeliveryMinute"
                                          isInvalid={formExpressSettingErrors.defaultEstimateDeliveryMinute}
                                          type="number" disabled={isSubmittingExpressSetting} min={0} placeholder="0"
                                          value={formExpressSettingState.defaultEstimateDeliveryMinute}
                                          onChange={handleExpressFormChange}/>
                            <Form.Control.Feedback
                                type="invalid">{formExpressSettingErrors.defaultEstimateDeliveryMinute}</Form.Control.Feedback>
                          </Col>
                        </Row>
                        <Row>
                          <Col sm={12} className="d-flex justify-content-center mt-4">
                            <Button variant="primary" disabled={isSubmittingExpressSetting}
                                    onClick={handleSubmitExpressSetting}>
                              {
                                isSubmittingExpressSetting ?
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    /> :
                                    null
                              }

                              <span className="pl-2 pr-2">Save</span>
                            </Button>
                          </Col>
                        </Row>
                      </ListGroup.Item>
                    </ListGroup>
                  </Form>
                </Col>
              </Row>
            </Tab>
          </Tabs>

          <Modal show={isShowUpdateModal}
                 animation={false}
                 onHide={handleCloseModal}
                 aria-labelledby="contained-modal-title-vcenter"
                 size="xs"
                 centered
          >
            <Form autoComplete="false">
              <Modal.Header closeButton>
                <Modal.Title>{formValues.id ? "Update" : "Add"}</Modal.Title>
              </Modal.Header>
              <Modal.Body key="modalBody">
                <Form.Group>
                  <Form.Label>Name</Form.Label>
                  <Form.Control type="text"
                                id="label"
                                name="label"
                                value={formValues.label}
                                isInvalid={formErrors.label}
                                placeholder="Label"
                                onChange={handleChange}
                  />
                  <Form.Control.Feedback type="invalid">{formErrors.label}</Form.Control.Feedback>
                </Form.Group>

                <Form.Group>
                  <Form.Label>Payment method</Form.Label><br/>
                  <FormControlLabel
                      style={{cursor: formValues.allowedPaymentMethod.includes("cash") && formValues.allowedPaymentMethod.length === 1? "not-allowed": "pointer"}}
                      control={<Checkbox name="allowedPaymentMethodCash"
                                         color="primary"
                                         style={{cursor: formValues.allowedPaymentMethod.includes("cash") && formValues.allowedPaymentMethod.length === 1? "not-allowed": "pointer"}}
                                         inputProps={{ 'aria-label': 'primary checkbox' }}
                                         checked={formValues.allowedPaymentMethod.includes("cash")}
                                         onChange={handleChange} value="cash"/>} label="Cash"/>
                  <FormControlLabel
                      style={{cursor: formValues.allowedPaymentMethod.includes("online") && formValues.allowedPaymentMethod.length === 1? "not-allowed": "pointer"}}
                      control={<Checkbox name="allowedPaymentMethodOnline"
                                         color="primary"
                                         style={{cursor: formValues.allowedPaymentMethod.includes("online") && formValues.allowedPaymentMethod.length === 1? "not-allowed": "pointer"}}
                                         inputProps={{ 'aria-label': 'primary checkbox' }}
                                         checked={formValues.allowedPaymentMethod.includes("online")}
                                         onChange={handleChange} value="online"/>} label="Online"/>
                </Form.Group>

                <Form.Group>
                  <Form.Label>Delivery max range(km)</Form.Label>
                  <Form.Control type="number"
                                id="deliveryMaxRange"
                                name="deliveryMaxRange"
                                isInvalid={formErrors.deliveryMaxRange}
                                value={formValues.deliveryMaxRange}
                                placeholder="Delivery max range"
                                onChange={handleChange}
                  />
                  <Form.Control.Feedback type="invalid">{formErrors.deliveryMaxRange}</Form.Control.Feedback>
                </Form.Group>
                <Form.Group>
                  <Form.Label>Delivery fee per km($)</Form.Label>
                  <Form.Control type="number"
                                id="deliveryFeePerKm"
                                name="deliveryFeePerKm"
                                placeholder="Delivery fee per km"
                                value={formValues.deliveryFeePerKm}
                                isInvalid={formErrors.deliveryFeePerKm}
                                onChange={handleChange}
                  />
                  <Form.Control.Feedback type="invalid">{formErrors.deliveryFeePerKm}</Form.Control.Feedback>
                </Form.Group>
                <Form.Group>
                  <Form.Label>Total amount to make free delivery($)</Form.Label>
                  <Form.Control type="number"
                                id="itemTotalToMakeDeliveryCostFree"
                                name="itemTotalToMakeDeliveryCostFree"
                                placeholder="Total amount to make free delivery($)"
                                value={formValues.itemTotalToMakeDeliveryCostFree}
                                isInvalid={formErrors.itemTotalToMakeDeliveryCostFree}
                                onChange={handleChange}
                  />
                  <Form.Control.Feedback
                      type="invalid">{formErrors.itemTotalToMakeDeliveryCostFree}</Form.Control.Feedback>
                </Form.Group>
                <Form.Group>
                  <Form.Label>Fixed delivery fee($)</Form.Label>
                  <Form.Control type="number"
                                id="deliveryFeeFixed"
                                name="deliveryFeeFixed"
                                placeholder="deliveryFeeFixed"
                                value={formValues.deliveryFeeFixed}
                                isInvalid={formErrors.deliveryFeeFixed}
                                onChange={handleChange}
                  />
                  <Form.Control.Feedback type="invalid">{formErrors.deliveryFeeFixed}</Form.Control.Feedback>
                </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="primary" disabled={isSubmitting || getFormErrors(formErrors)} onClick={handleSubmit}>
                  {
                    isSubmitting ?
                        <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                        /> :
                        null
                  }

                  <span className="pl-2 pr-2">Save</span>
                </Button>
                <Button variant="secondary" disabled={isSubmitting}
                        onClick={handleCloseModal}>Close</Button>
              </Modal.Footer>
            </Form>
          </Modal>

          <Dialog
            open={openDialog.normal}
            onClose={handleToggleNormalDialog("close")}
            fullWidth
            maxWidth="xl"
            scroll="body"
            classes={{
              scrollPaper: classes.topScrollPaper,
              paperScrollBody: classes.topPaperScrollBody,
            }}
          >
            <DialogTitle>Previous Normal Settings</DialogTitle>
            <DialogContent dividers>
              <TableContent>
                <Paper>
                  <TableContainer style={{ maxHeight: window.innerHeight - 280 }}>
                    <MTable stickyHeader>
                      <TableHead>
                        <TableRow>
                          <TableCell align="left">Name</TableCell>
                          <TableCell align="left">Delivery max range(km)</TableCell>
                          <TableCell align="left">Delivery fee per km($)</TableCell>
                          <TableCell align="left">Total amount to make free deli($)</TableCell>
                          <TableCell align="left">Fixed delivery fee($)</TableCell>
                          <TableCell align="left">Payment methods</TableCell>
                          <TableCell align="left">Modifier</TableCell>
                          <TableCell align="left">Modified at</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody style={{ position: "relative" }}>
                        {dialogLoading.normal && (
                            <div
                              style={{
                                display: "block",
                                position: "absolute",
                                inset: 0,
                                background: "rgb(166 166 166 / 20%)",
                              }}
                            >
                            </div>
                          )}
                        {previousNormalSettings?.list?.length > 0 ? (
                          previousNormalSettings?.list?.map((row) => {
                            const { data, modified_data } = row;
                            return (
                              <TableRow key={row.id} hover>
                                <TableCell
                                  className={getModifiedColClass(modified_data, "label")}
                                >
                                  {data.label}
                                </TableCell>
                                <TableCell
                                  className={getModifiedColClass(
                                    modified_data,
                                    "deliveryMaxRange"
                                  )}
                                >
                                  {data.deliveryMaxRange}
                                </TableCell>
                                <TableCell
                                  className={getModifiedColClass(
                                    modified_data,
                                    "deliveryFeePerKm"
                                  )}
                                >
                                  <FormattedNumber
                                    value={data.deliveryFeePerKm}
                                    style="currency"
                                    currency="USD"
                                  />
                                </TableCell>
                                <TableCell
                                  align="left"
                                  className={getModifiedColClass(
                                    modified_data,
                                    "itemTotalToMakeDeliveryCostFree"
                                  )}
                                >
                                  <FormattedNumber
                                    value={data?.itemTotalToMakeDeliveryCostFree}
                                    style="currency"
                                    currency="USD"
                                  />
                                </TableCell>
                                <TableCell
                                  align="left"
                                  className={getModifiedColClass(
                                    modified_data,
                                    "deliveryFeeFixed"
                                  )}
                                >
                                  <FormattedNumber
                                    value={data?.deliveryFeeFixed}
                                    style="currency"
                                    currency="USD"
                                  />
                                </TableCell>
                                <TableCell
                                  align="left"
                                  className={`${getModifiedColClass(
                                    modified_data,
                                    "allowedPaymentMethod"
                                  )} allowedPaymentMethod`}
                                >
                                  {data.allowedPaymentMethod.includes("cash") && (
                                    <Chip
                                      variant="outlined"
                                      color="secondary"
                                      size="small"
                                      label="Cash"
                                      className="ml-1 mr-1"
                                    />
                                  )}
                                  {data.allowedPaymentMethod.includes("online") && (
                                    <Chip
                                      variant="outlined"
                                      color="primary"
                                      size="small"
                                      label="Online"
                                      className="ml-1 mr-1"
                                    />
                                  )}
                                </TableCell>
                                <TableCell align="left">{row?.modifier}</TableCell>
                                <TableCell align="left">
                                  {moment(row?.createdAt).format("DD/MMM/YY - hh:mm A")}
                                </TableCell>
                              </TableRow>
                            );
                          })
                        ) : (
                          <TableRow>
                            <TableCell align="center" colSpan={8}>
                              No Data
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </MTable>
                  </TableContainer>
                  <div
                    style={{
                      display: "block",
                      width: "100%",
                      height: "5px",
                    }}
                  >
                    {dialogLoading.normal && <LinearProgress variant="query" />}
                  </div>
                  <TablePagination
                    key="normal-pagination"
                    component="div"
                    page={page.normal}
                    rowsPerPage={limit.normal}
                    rowsPerPageOptions={[5, 10, 25, 50]}
                    count={previousNormalSettings?.total}
                    onPageChange={handleChangeNormalPage}
                    onRowsPerPageChange={handleChangeNormalRowsPerPage}
                  />
                </Paper>
              </TableContent>
            </DialogContent>
            <DialogActions>
              <MButton variant="text" onClick={handleToggleNormalDialog("close")}>
                Close
              </MButton>
            </DialogActions>
          </Dialog>

          <Dialog
            open={openDialog.express}
            onClose={handleToggleExpressDialog("close")}
            fullWidth
            maxWidth="xl"
            scroll="body"
            classes={{
              scrollPaper: classes.topScrollPaper,
              paperScrollBody: classes.topPaperScrollBody,
            }}
          >
            <DialogTitle>Previous Express Settings</DialogTitle>
            <DialogContent dividers>
              <TableContent>
                <Paper>
                  <TableContainer style={{ maxHeight: window.innerHeight - 280 }}>
                    <MTable stickyHeader>
                      <TableHead>
                        <TableRow>
                          <TableCell align="left">Maximum orders accepted</TableCell>
                          <TableCell align="left">Delivery max range(km)</TableCell>
                          <TableCell align="left">Delivery fee per km($)</TableCell>
                          <TableCell align="left">
                            Total amount to make free delivery($)
                          </TableCell>
                          <TableCell align="left">Fixed delivery fee($)</TableCell>
                          <TableCell align="left">Estimate delivery time(minute)</TableCell>
                          <TableCell align="left">Modifier</TableCell>
                          <TableCell align="left">Modified at</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody style={{ position: "relative" }}>
                        {dialogLoading.express && (
                          <div
                            style={{
                              display: "block",
                              position: "absolute",
                              inset: 0,
                              background: "rgb(166 166 166 / 20%)",
                            }}
                          >
                          </div>
                        )}
                        {previousExpressSettings?.list?.length ? (
                          previousExpressSettings?.list?.map((row) => {
                            const { data, modified_data } = row;
                            return (
                              <TableRow key={row?.id} hover>
                                <TableCell
                                  align="left"
                                  className={getModifiedColClass(modified_data, "slot_count")}
                                >
                                  {data?.slot_count}
                                </TableCell>
                                <TableCell
                                  align="left"
                                  className={getModifiedColClass(
                                    modified_data,
                                    "delivery_max_range"
                                  )}
                                >
                                  {data?.delivery_max_range}
                                </TableCell>
                                <TableCell
                                  align="left"
                                  className={getModifiedColClass(
                                    modified_data,
                                    "delivery_fee_per_km"
                                  )}
                                >
                                  <FormattedNumber
                                    value={data?.delivery_fee_per_km}
                                    style="currency"
                                    currency="USD"
                                  />
                                </TableCell>
                                <TableCell
                                  align="left"
                                  className={getModifiedColClass(
                                    modified_data,
                                    "item_total_to_make_delivery_cost_free"
                                  )}
                                >
                                  <FormattedNumber
                                    value={data?.item_total_to_make_delivery_cost_free}
                                    style="currency"
                                    currency="USD"
                                  />
                                </TableCell>
                                <TableCell
                                  align="left"
                                  className={getModifiedColClass(
                                    modified_data,
                                    "delivery_fee_fixed"
                                  )}
                                >
                                  <FormattedNumber
                                    value={data?.delivery_fee_fixed}
                                    style="currency"
                                    currency="USD"
                                  />
                                </TableCell>
                                <TableCell
                                  align="left"
                                  className={getModifiedColClass(
                                    modified_data,
                                    "default_estimate_delivery_minute"
                                  )}
                                >
                                  {data?.default_estimate_delivery_minute}
                                </TableCell>
                                <TableCell align="left">{row?.modifier}</TableCell>
                                <TableCell align="left">
                                  {moment(row?.createdAt).format("DD/MMM/YY - hh:mm A")}
                                </TableCell>
                              </TableRow>
                            );
                          })
                        ) : (
                          <TableRow>
                            <TableCell align="center" colSpan={8}>
                              No Data
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </MTable>
                  </TableContainer>
                  <div
                    style={{
                      display: "block",
                      width: "100%",
                      height: "5px",
                    }}
                  >
                    {dialogLoading.express && <LinearProgress variant="query" />}
                  </div>
                  <TablePagination
                    key="express-pagination"
                    component="div"
                    page={page.express}
                    rowsPerPage={limit.express}
                    rowsPerPageOptions={[5, 10, 25, 50]}
                    count={previousExpressSettings?.total}
                    onPageChange={handleChangeExpressPage}
                    onRowsPerPageChange={handleChangeExpressRowsPerPage}
                  />
                </Paper>
              </TableContent>
            </DialogContent>
            <DialogActions>
              <MButton variant="text" onClick={handleToggleExpressDialog("close")}>
                Close
              </MButton>
            </DialogActions>
          </Dialog>

          <Toast className={toastBgColor}
                 onClose={() => setShowToast(false)}
                 show={showToast}
                 delay={3000}
                 autohide
                 style={{
                   position: 'fixed',
                   top: 70,
                   right: 35,
                   zIndex: 1041,
                   width: "300px"
                 }}
          >
            <Toast.Header>
              <strong className="mr-auto m-3">{toastMessage}</strong>
            </Toast.Header>
          </Toast>

        </HelpPageWrapper>
      </CustomModal>
  );
}

export default DeliExpressSettings;
